import React from 'react';

import SearchFilterItem from './SearchFilterItem.js';
import DefaultFilterItem from './DefaultFilterItem.js';
import ToggleFilterItem from './ToggleFilterItem.js';
import ButtonFilterItem from './ButtonFilterItem.js';
import DatePickerFilterItem from './DatePickerFilterItem.js';

const FilterItem = ({ item }) => {
  return (
    {
      datePicker: <DatePickerFilterItem item={item} />,
      toggle: <ToggleFilterItem item={item} />,
      button: <ButtonFilterItem item={item} />,
      search: <SearchFilterItem item={item} />,
    }[item.type] || <DefaultFilterItem item={item} />
  );
};

export default FilterItem;
